import { createSelector } from 'reselect';
import { getAccessoriesPromoData } from '../promo/sharedCartPromoSelectors';

export const getAccessoryCode = accessory => (
    accessory.get('code', '')
);

/**
 * Get the label for the provided accessory
 * @param {Immutable.Map} accessory - the accessory
 * @returns {string} label for the provided accessory.
 */
export const getAccessoryLabel = accessory => (
    accessory.get('label', '')
);

/**
 * Get the image of the provided accessory
 * @param {Immutable.Map} accessory - the accessory
 * @return {string} the url of the image
 */
export const getAccessoryImage = accessory => (
    accessory.getIn(['images', 'FULL'], '')
);

/**
 * Get the cost for the provided accessory by currency
 * @param {Immutable.Map} accessory - the accessory
 * @param {Immutable.Map} accessoryPromoData - accessory promo rewards if any
 * @param {string} currency - the currency of the item
 * @returns {string} cost for the provided accessory.
 */
export const getAccessoryCostByCurrency = (accessory, accessoryPromoData, currency) => {
    const accessoryCode = getAccessoryCode(accessory);
    if (accessoryPromoData.has(accessoryCode)) {
        const matchingAccessory = accessoryPromoData.get(accessoryCode);
        return matchingAccessory.get('updatedCost', '0');
    }
    return accessory.getIn(['costs', currency, 'cost'], '0');
};

export const formatAccessoryMessage = (intl, accessory, type, values = {}) => {
    const accessoryMessageKey = `${type}.${getAccessoryCode(accessory)}`;
    const message = intl.messages[accessoryMessageKey];
    const labelExists = message && (typeof message === 'string') && (message.trim().length > 0);

    return labelExists
        ? intl.formatMessage({ id: accessoryMessageKey }, values)
        : '';
};

export const getHasAccessoryPromo = createSelector(
    getAccessoriesPromoData,
    accessoryPromoData => accessory => accessoryPromoData.has(getAccessoryCode(accessory))
);
